import React, { useContext } from 'react'

import { TripMapContext } from 'tripPlanner/contexts/TripMapContext'
import LEExperienceSummaryCard from '../SummaryCards/LEOffer/LEExperienceSummaryCard'
import LEHotelSummaryCard from '../SummaryCards/LEOffer/LEHotelSummaryCard'
import { isExperienceOffer } from 'lib/offer/offerTypes'

interface Props {
  offer: App.HotelOffer | App.ExperienceOffer | undefined
}

function LEOfferCard({ offer }: Props) {
  const { onDeselectMapItem } = useContext(TripMapContext)

  if (!offer) return null

  if (isExperienceOffer(offer)) {
    return <LEExperienceSummaryCard experience={offer} onClose={onDeselectMapItem} />
  }

  return <LEHotelSummaryCard offer={offer} onClose={onDeselectMapItem} />
}

export default LEOfferCard
